const UserPayoutsTwo = () => {
  return (
    <>
      <div className=" main-page">
        <div className="container mx-auto">
          <div className="row d-flex justify-content-center">
            <div className=" w-60 mx-auto pt-4">
              <div className="card border-radius-2xl border p-5">
                <div className=" d-flex justify-content-center text-center mb-4">
                  <div>
                    <img
                      src="../../assets/img/salarlogo.png"
                      height="140"
                      alt=""
                    />
                    <div className=" mt-n3 lh-sm">
                      <div>
                        <b className=" text-black fw-bolder text-3xl">
                          Customer Payout Receipt
                        </b>
                      </div>
                      <div>
                        <b className=" text-black fw-normal">(www.salar.in)</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center text-start pt-4 pb-4 px-4">
                  <div className=" w-100">
                    {" "}
                    <b className="text-black fw-bolder text-md text-start">
                      Date : <b className=" fw-bold text-black">11-10-2025</b>{" "}
                    </b>
                  </div>
                  <div className=" w-100">
                    <b className="text-black fw-bolder text-md text-start">
                      Transaction ID :{" "}
                      <b className=" fw-bold text-black">WR1742878986723</b>{" "}
                    </b>
                  </div>
                  <div className=" w-100 text-end">
                    <b className="text-black fw-bolder text-md text-start">
                      Status : <b className=" fw-bold text-black">Successful</b>{" "}
                    </b>
                  </div>
                </div>
                <div className=" d-flex justify-content-start align-items-start text-start pt-4 pb-4 px-4 gap-6">
                  <div className=" w-80">
                    <div className="mt-2 border-bottom">
                      <h3 className=" fw-bolder text-black">
                        Customer Details
                      </h3>
                    </div>
                    <div className=" pt-3 pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        User Type :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          regular
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Name :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Siddharth
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Register ID :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          S96E863
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Email ID :{" "}
                        <b className=" fw-bold text-black">
                          siddharthsid3024@gmail.com
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Gender :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Male
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Address :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          6-9-779 KB Layout, Sanjeevayi Nagar
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        City :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Tirupati
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        State :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Andhra Pradesh
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Pincode :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          517501
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Country :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          India
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Mobile :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          +91 8919180171
                        </b>{" "}
                      </b>
                    </div>
                  </div>
                  <div className=" w-80">
                    <div className="mt-2 border-bottom">
                      <h3 className=" fw-bolder text-black">
                        Customer Bank Details
                      </h3>
                    </div>
                    <div className=" pt-3 pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Country :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          India
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Name in A/c :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Siddharth
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        A/C No :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          1440166000038079
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        A/C Type :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Savings
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        IFSC Code :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          KVBL0001440
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Branch Name :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Tirupati Khadhi Colony
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Pan Card No: :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          BAVPL8983P
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        Aadhar Card No :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          965524565187
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        KYC DOC Name: :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          Aadhar Card
                        </b>{" "}
                      </b>
                    </div>
                    <div className="pb-2">
                      <b className="text-black fw-bolder text-md text-start">
                        KYC DOC No :{" "}
                        <b className=" fw-bold text-black text-capitalize">
                          965524565187
                        </b>{" "}
                      </b>
                    </div>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-3">
                  <div className="mt-2 border-bottom">
                    <h5 className=" fw-bolder text-black">Payout Details</h5>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-4">
                  <div className="table-responsive">
                    <table className="table text-center  table-bordered align-items-center mb-0">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            S.NO
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Description
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Requested Amount <br /> (After admin charges)
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            TDS on Amount
                          </th>
                          <th className=" text-dark text-md font-weight-bolder text-black">
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">
                        <tr>
                          <td className=" text-dark text-md font-weight-bold">
                            1
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            Performance Incentive Referral Commission
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>753.3
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>37.665
                          </td>
                          <td className=" text-dark text-md font-weight-bold">
                            <sup>₹</sup>715.635
                          </td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-3 text-end">
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      Total :{" "}
                      <b className=" fw-bold text-black text-capitalize">
                        <sup>₹</sup>715.635
                      </b>{" "}
                    </b>
                  </div>
                </div>
                <div className=" w-100 px-4 pb-3 text-end">
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      For Sworld Solutions PVT.Ltd :
                    </b>
                  </div>
                  <div className="mt-2">
                    <img src="" alt="" />
                  </div>
                  <div className="mt-2">
                    <b className="text-black fw-bolder text-2xl text-start">
                      Authorized Signatory
                    </b>
                  </div>
                </div>
                <div className=" w-100 px-4 pt-4 text-center">
                  <b className=" text-uppercase fw-bolder text-5xl text-black">
                    Salar
                  </b>
                  <br />
                  <b className=" text-black fw-normal fs-4">
                    If you encounter any issues related to the Payout receipt,
                    you can contact us at
                  </b>
                  <br />
                  <b className="fw-bolder text-2xl text-black">
                    refpayout@salar.in
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPayoutsTwo;
